export const getEnv = () => {
    if (process.env.NODE_ENV === 'production') {
        return {
            usa_instituicao_cliente_filial: 'S',
            usa_registro_academico_automatico: 'N',
            VERSION: process.env.VERSION
        }
    }
    return {
        ...process.env
    }
}
